import { request } from "./http";

export interface Specialty {
  id: number;
  name: string;
  room_id?: number | null;
}

export const listCompanySpecialties = () =>
  request<Specialty[]>('/api/company/specialties');

export const createCompanySpecialty = (body: { name: string; room_id?: number | null }) =>
  request<Specialty>(`/api/company/specialties`, {
    method: 'POST',
    body: JSON.stringify(body)
  });

export const updateCompanySpecialty = (id: number, body: { name?: string; room_id?: number | null }) =>
  request<Specialty>(`/api/company/specialties/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body)
  });

export const deleteCompanySpecialty = (id: number) =>
  request<void>(`/api/company/specialties/${id}`, { method: 'DELETE' });

